<template>
    <sd-mask v-if="isShow" @click.native="hidden()">
        <div class="project-sheet" ref="projectsheet" :class="[{'hidden': isHidden}]" @click.stop :style="sheetStyle">
            <div class="header" @touchstart="start" @touchmove="move" @touchend="end">
                <div class="text" v-if="title">{{title}}</div>
                <div class="line" v-else></div>
                <div class="close" v-if="close || (close == '')" @click="hidden()"><img src="@/assets/img/sheet_close.png" /></div>
            </div>
            <div class="sheet-content">
                <slot></slot>
            </div>
        </div>
    </sd-mask>
</template>

<script>

export default {
    name: "sd-sheet",
    props: {
        show: Boolean,
        title: String,
        close: Boolean | String,
    },
    data() {
        return {
            isShow: this.show || false,
            isHidden: false,

            startPageY: 0,
            moveY: 0
        }
    },

    computed: {
        sheetStyle() {
            let moveY = this.moveY > 0? this.moveY : 0;
            return `transform: translate(0, ${moveY}px);`;
        }
    },
    watch: {
        show(val) {
            this.isShow = val;
        },
        isShow(val) {
            this.$emit("update:show", val)
        }
    },
    methods: {
        hidden() {
            this.isHidden = true;
            setTimeout(() => {
                this.isHidden = false;
                this.isShow = false;
            }, 300)
        },

        start(event) {
            this.setMove(event, "start");
        },

        move(event) {
            this.setMove(event, "move")
        },

        end(event) {
            this.setMove(event, "end")
        },

        setMove(e, type) {
            let touch = e.changedTouches[0] || {}, pageY = touch.pageY;
            if(type == "start") {
                this.startPageY = pageY;
            }else if(type == "move") {
                let moveY = pageY - this.startPageY;
                this.moveY = moveY;
                console.log(this.moveY)
            }else {
                let h = this.$refs.projectsheet.offsetHeight;
                if((this.moveY / h) > 0.3) {
                    this.hidden();
                }else {
                    this.moveY = 0;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .project-sheet {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        animation:showSheet 0.3s ease-out;
        z-index: 99;

        &.hidden {
            animation:hiddenSheet 0.3s ease-out;
            animation-fill-mode: forwards;
        }

        .header {
            position: relative;
            padding-top: 12px;
            background: white;
            border-radius: 13px 13px 0px 0px;

            .line {
                width: 70px;
                height: 5px;
                background: #DADDE2;
                margin: 0 auto;
                border-radius: 2.5px;
            }

            .text {
                font-size: 17px;
                color: #000000;
                font-weight: bold;
                line-height: 32px;
                padding-top: 4px;
                text-align: center
            }

            .close {
                width: 32px;
                height: 32px;
                position: absolute;
                right: 16px;
                bottom: 0;
            }
        }

        .sheet-content {
            background: white;
        }
    }

    @keyframes showSheet
    {
        from {transform: translateY(100%);}
        to {transform:none;}
    }
    
    @keyframes hiddenSheet
    {
        from {transform:none;}
        to {transform: translateY(100%);}
    }
</style>


// WEBPACK FOOTER //
// src/components/common/sheet.vue